// extracted by mini-css-extract-plugin
module.exports = {"page":"styles-module--page--1Ratj","container":"styles-module--container--2RJi7","rechartsTooltipLabel":"styles-module--recharts-tooltip-label--2mOZW"};